import React from 'react';

const AsyncSpeakerList = React.lazy(() => import('./ListContainer'));

export const SpeakerList = () => {
  return <AsyncSpeakerList />;
};
